// Risolve da quale CAPO BASE un capo deriva (metodologia Burgo: molte
// costruzioni partono da "il corpetto base", "la base manica", ecc.).
// Heuristica per categoria + sezione, con override espliciti per nome.

import type { GarmentContent, GarmentCategory } from '../types/records'

// Nomi dei capi base presenti nel catalogo Burgo estratto
const BASE_BY_CATEGORY: Partial<Record<GarmentCategory, string>> = {
  bodice: 'Base semplice del corpetto',
  dress: 'Base semplice del corpetto',
  blouse: 'Base semplice del corpetto',
  shirt: 'Base semplice del corpetto',
  jacket: 'Base semplice del corpetto',
  coat: 'Base semplice del corpetto',
  vest: 'Base semplice del corpetto',
  sleeve: 'Manica base a due pezzi',
  skirt: 'Base della gonna diritta',
  trousers: 'Culotte base',
}

// I capi base stessi non ereditano (evita ricorsione)
const BASE_NAMES = new Set([
  'Base semplice del corpetto',
  'Abito base con riprese',
  'Manica base a due pezzi',
  'Base manica',
  'Base della gonna diritta',
  'Culotte base',
  'Base camicia uomo',
])

export function isBaseGarment(name: string): boolean {
  return BASE_NAMES.has(name)
}

export function resolveBaseName(g: GarmentContent): string | null {
  if (isBaseGarment(g.name)) return null
  if (g.section !== 'donna') return null // basi note solo per donna
  return BASE_BY_CATEGORY[g.category] ?? null
}
